export const QUERY_KEYS = {
    countriesV3: 'countriesV3',
    regions: 'regions',
    cities: 'cities',
    filter_countries: 'filter-countries',
    languages: 'languages',
    filter_languages: 'filter-languages',
    languagesV3: 'languagesV3'
}
